.recommendation {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.recommendation__text {
    &:empty {
        display: none;
    }
}

.recommendation__widget {
    border: 1px solid #d6d9e0;
    border-radius: 12px;
    padding: 12px;
    background: #f8faff;
}

.recommendation__widgetLabel {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #3a3f8f;
    margin-bottom: 8px;
}
